import TablePagination from '@/components/common/Pagination/TablePagination';
import * as S from './style';
import { useGetAbstractListApi } from '@/api/conference';
import { useState } from 'react';
import { CONF_TITLE } from '@/constants/menu';
import ArrowLeftIcon from '@/components/Icon/ArrowLeftIcon';
import { useNavigate } from 'react-router-dom';

const GreenConfirm = () => {
	const navigate = useNavigate();

	const [page, setPage] = useState(1);

	const { data: abstractListData } = useGetAbstractListApi({
		conference_name: CONF_TITLE,
		page: page,
		row: 10,
	});

	const handleBackButton = () => {
		navigate(-1);
	};

	return (
		<S.Container noData={abstractListData?.abstract?.length === 0}>
			<S.BackButton onClick={handleBackButton}>
				<ArrowLeftIcon iconColor="#01337D" width="16" height="16" />
				<span>이전화면으로</span>
			</S.BackButton>
			{abstractListData?.abstract?.length !== 0 ? (
				<TablePagination activePage={page} totalItems={abstractListData?.total_count} onChange={(page) => setPage(page)}>
					<S.TableBox>
						{abstractListData?.abstract?.map((item, index) => (
							<S.TableItem key={index}>
								<S.TableContent>
									<p className="date">{item.abstract_enrollment_date}</p>
									<p>{item.abstract_conference_name}</p>
								</S.TableContent>
								<S.Button href={item.file_path} target="_blank" rel="noopener noreferrer">
									초록 확인
								</S.Button>
							</S.TableItem>
						))}
					</S.TableBox>
				</TablePagination>
			) : (
				<S.NoData>등록 내역이 없습니다.</S.NoData>
			)}
		</S.Container>
	);
};
export default GreenConfirm;
